import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Trophy, Users, TrendingUp, Award } from "lucide-react";
import volleyballApi from "@/services/api";

export const StatsOverview = () => {
  const { championshipId } = useParams();
  const [standings, setStandings] = useState([]);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      if (!championshipId) return;
      
      try {
        const [standingsData, matchesData] = await Promise.all([
          volleyballApi.getChampionshipStandings(championshipId),
          volleyballApi.getChampionshipMatches(championshipId)
        ]);
        setStandings(standingsData);
        setMatches(matchesData);
      } catch (error) {
        console.error("Error loading stats:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [championshipId]);
  
  if (loading) {
    return null;
  }
  
  const totalTeams = standings.length;
  const totalMatches = matches.filter(m => m.played).length;
  const leader = standings[0] || {};
  
  const stats = [
    {
      icon: Users,
      label: "Squadre",
      value: totalTeams,
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: TrendingUp,
      label: "Partite Giocate",
      value: Math.floor(totalMatches),
      color: "text-secondary",
      bgColor: "bg-secondary/10",
    },
    {
      icon: Trophy,
      label: "Leader",
      value: leader.team,
      subValue: `${leader.points} punti`,
      color: "text-accent",
      bgColor: "bg-accent/10",
      isText: true,
    },
    {
      icon: Award,
      label: "Giornate",
      value: "26",
      subValue: "Totali",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
  ];
  
  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold mb-3">Statistiche Campionato</h2>
          <p className="text-muted-foreground">Dati aggiornati in tempo reale</p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <Card key={index} className="p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-start justify-between mb-4">
                  <div className={`w-12 h-12 rounded-lg ${stat.bgColor} flex items-center justify-center`}>
                    <Icon className={`w-6 h-6 ${stat.color}`} />
                  </div>
                </div>
                <div className="text-sm text-muted-foreground mb-1">{stat.label}</div>
                <div className="text-2xl font-bold mb-1">
                  {stat.isText ? (
                    <div className="text-lg leading-tight">{stat.value}</div>
                  ) : (
                    stat.value
                  )}
                </div>
                {stat.subValue && (
                  <div className="text-sm text-muted-foreground">{stat.subValue}</div>
                )}
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
